module.exports = __webpack_public_path__ + "static/img/logo_32.cc50e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_32.png
// module id = FgHe
// module chunks = 1